<template>
  <div class="dialog_box">
    <el-dialog title="确认意见" :visible="show" width="437px" @close="dialogClose" top="20vh" :close-on-click-modal="false">
      <div class="dialog_container">
        <el-form ref="form" class="form_box" :model="form" label-width="110px" :rules="rules">
          <el-form-item label="确认人员">
            <el-input placeholder="默认当前账号为确认人员" disabled></el-input>
          </el-form-item>
          <el-form-item label="审核状态" prop="isPass">
            <el-radio v-model="form.isPass" :label="true">通过</el-radio>
            <el-radio v-model="form.isPass" :label="false">驳回</el-radio>
          </el-form-item>
          <el-form-item label="备注" :prop="form.isPass ? '' : 'reason'">
            <el-input v-model="form.reason" type="textarea" placeholder="请输入备注"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="btn" @click="dialogClose">取 消</el-button>
        <el-button class="btn btn_ok" @click="confirm('form')">提 交</el-button>
      </span>
    </el-dialog>
    <preview-image :show.sync="dialogVisible" :name="dialogImageName" :path="dialogImageUrl" />
  </div>
</template>

<script>
import previewImage from "@/components/previewImage.vue";
export default {
  name: "",
  data () {
    return {
      form: {
        isPass: null,
      },
      rules: {
        isPass: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reason: [{ required: true, message: "请输入备注", trigger: "bulur" }]
      },
      headers: {},
      dialogImageUrl: "",
      dialogImageName: "",
      dialogVisible: false,
    };
  },
  components: {
    previewImage,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: {},
    },
  },
  created () {
    this.headers = {
      Authorization: sessionStorage.getItem("Token"),
      "Content-Type": "multipart/form-data",
    };
  },
  methods: {
    dialogClose () {
      this.$emit("update:show", false);
    },
    confirm (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.form.orderId = this.data.id;
        this.$http.confirmAdvice(this.form).then((res) => {
          if (res.code === 0) {
            this.form = {};
            this.$parent.getList();
            this.$emit("update:show", false);
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    uploadFile (file) {
      console.log(file);
      const formData = new FormData();
      formData.append("file", file.file);
      formData.append("datePath", `/收费凭证/${this.data.id}/`);
      this.$http.commonUploadFile(formData).then((res) => {
        if (res.code === 0) {
          this.form.filePath = res.data.filePath;
          this.form.cert = res.data.fileHandlerPath;
          this.form.fileName = res.data.fileName;
        } else {
          this.$message.error("上传失败，请稍后再试！");
        }
      });
    },
    beforeAvatarUpload (file) {
      console.log(file.type);
      const isType =
        file.type == "image/jpg" ||
        file.type == "image/jpeg" ||
        file.type == "image/png";
      const isLt20M = file.size / 1024 / 1024 < 20;
      if (!isType || !isLt20M) {
        this.$message.error("请上传格式为jpg、jpeg、png、pdf、doc、docx且大小不超过20M的图片或文件");
      }
      return isType && isLt20M;
    },
    handleRemove () {
      this.form.cert = "";
      this.form.filePath = "";
      this.form.fileName = "";
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = this.form.filePath;
      this.dialogImageName = file.fileName;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/css/dialog";

/deep/.el-dialog__body {
  overflow-y: visible !important;
}
</style>



// WEBPACK FOOTER //
// src/views/feedback/component/confirmOrder.vue